import {RequestInformation} from "../guestRequest/RequestInformation";
import {SignOrder} from "../../component/SignOrder";
import {OrderInformation} from "../../component/OrderInformation";


export const UpdateQrOrder = ({orderInfo, signed}) =>{

    return(<>
        <h1>Bestellung bestätigen</h1>
        <SignOrder order={orderInfo} signed={signed} canceled={() => {}} tanFailed={() => {}}
                   isPublic={true}>
            <OrderInformation order={orderInfo} showUser={false}/>
        </SignOrder>
    </>)

}